import { AddConclusionMenuButton } from '@fs/zion-conclusion'
import type { Person } from '@fs/zion-tree-types'
import React from 'react'

type Props = {
  person: Person | undefined
}

export default function AddConclusionMenuButtonOtherFactOrEvent({ person }: Props): JSX.Element | null {
  return (
    /* eslint-disable-next-line test-selectors/button -- NA */
    <AddConclusionMenuButton
      conclusionCategory="otherFactOrEvent"
      person={person}
      conclusionTypesToDisable={
        /** These are intentionally disabled for all living persons as a FamilySearch privacy policy decision — these fields are considered potentially sensitive, regardless of whether one already exists. This is distinct from the AddConclusionMenuOverlay's automatic singular-event disabling, which only activates when a value is already present. See the README for full context and the policy source. */
        person?.living
          ? [
              'RACE',
              'TRIBE_NAME',
              'NATIONAL_ID',
              'CLAN_NAME',
              'CASTE_NAME',
              'BAR_MITZVAH',
              'BAS_MITZVAH',
              'RELIGIOUS_AFFILIATION',
            ]
          : undefined
      }
    />
  )
}
